import gql from 'graphql-tag'

export const initShopStatistics = gql`
query initShopStatistics($params: StatisticShopParams!) {
	cashAssist {
      initShopStatistics(params: $params)
  }
}
`

export const getShopStatisticsData = gql`
	query getShopStatisticsData($requestId: ID!) {
		cashAssist {
			getStatisticsData(requestId: $requestId) {
				status
				progress
				data {
					...on StatisticShop {
						number
						productCount
						productPerCustomer
						name
						dateTime
						eft
						eftCount
						cashRegisterFilter
						loyaltyCard
						loyaltyCardCount
						userId
						cashRegisterId
						orderTotal
						priceByOne
						returnCount
						returnDifference
						returnPerOrder
						returnTotal
						total
						totalPerHour
						totalMinutes
						totalPerTime
						totalTime
						totalPerProductCount
						totalPerEftCount
						totalPerLoyaltyCardCount
						returnRate
						salesGroups {
							label
							value
						}
					}
				}
			}
		}
	}
`

